import { useCallback, useEffect, useRef } from "react";

const JotForm = ({ formId }) => {
  const iframeRef = useRef();

  const isPermitted = useCallback((originUrl, whitelisted_domains) => {
    const url = document.createElement("a");
    url.href = originUrl;
    const hostname = url.hostname;
    let result = false;
    if (typeof hostname !== "undefined") {
      whitelisted_domains.forEach(function (element) {
        if (
          hostname.slice(-1 * element.length - 1) === ".".concat(element) ||
          hostname === element
        ) {
          result = true;
        }
      });
      return result;
    }
  }, []);

  const handleIFrameMessage = useCallback(
    e => {
      if (typeof e.data === "object") {
        return;
      }
      const args = e.data.split(":");
      const _formId = args[args.length - 1];
      if (_formId !== formId) {
        return;
      }
      let src, script;

      switch (args[0]) {
        case "scrollIntoView":
          iframeRef.current.scrollIntoView();
          break;
        case "setHeight":
          iframeRef.current.style.height = args[1] + "px";
          break;
        case "collapseErrorPage":
          if (iframeRef.current.clientHeight > window.innerHeight) {
            iframeRef.current.style.height = window.innerHeight + "px";
          }
          break;
        case "reloadPage":
          window.location.reload();
          break;
        case "loadScript":
          if (!isPermitted(e.origin, ["jotformeu.com", "jotform.pro"])) {
            break;
          }
          src = args[1];
          if (args.length > 3) {
            src = args[1] + ":" + args[2];
          }
          script = document.createElement("script");
          script.src = src;
          script.type = "text/javascript";
          document.body.appendChild(script);
          break;
        case "exitFullscreen":
          if (window.document.exitFullscreen) window.document.exitFullscreen();
          else if (window.document.mozCancelFullScreen)
            window.document.mozCancelFullScreen();
          else if (window.document.mozCancelFullscreen)
            window.document.mozCancelFullScreen();
          else if (window.document.webkitExitFullscreen)
            window.document.webkitExitFullscreen();
          else if (window.document.msExitFullscreen)
            window.document.msExitFullscreen();
          break;
        default:
      }

      const isJotForm = e.origin.indexOf("jotform") > -1 ? true : false;
      if (isJotForm) {
        const urls = {
          docurl: encodeURIComponent(document.URL),
          referrer: encodeURIComponent(document.referrer)
        };
        iframeRef.current?.contentWindow?.postMessage(
          JSON.stringify({ type: "urls", value: urls }),
          "*"
        );
      }
    },
    [formId, isPermitted]
  );

  useEffect(() => {
    if (iframeRef.current) {
      let src = iframeRef.current.src;
      let iframeParams = [];
      if (window.location.href && window.location.href.indexOf("?") > -1) {
        iframeParams = iframeParams.concat(
          window.location.href
            .substr(window.location.href.indexOf("?") + 1)
            .split("&")
        );
      }
      if (src && src.indexOf("?") > -1) {
        iframeParams = iframeParams.concat(
          src.substr(src.indexOf("?") + 1).split("&")
        );
        src = src.substr(0, src.indexOf("?"));
      }
      iframeParams.push("isIframeEmbed=1");
      iframeRef.current.src = src + "?" + iframeParams.join("&");
    }

    window.addEventListener("message", handleIFrameMessage, false);

    return () => {
      window.removeEventListener("message", handleIFrameMessage, false);
    };
  });

  return (
    <iframe
      ref={iframeRef}
      id={`JotFormIFrame-${formId}`}
      title="Golv söker hem"
      // eslint-disable-next-line react/no-unknown-property
      allowTransparency
      allowFullScreen
      allow="geolocation; microphone; camera"
      src={`https://form.jotformeu.com/${formId}`}
      frameBorder="0"
      style={{
        minWidth: "100%",
        height: "539px",
        border: "none"
      }}
      scrolling="no"
    />
  );
};

export default JotForm;
